/**
 * @file Contém enums referente aos documentos
 */
const documentos = {
    TAMANHO_LIMITE_PARA_VISUALIZACAO: 20971520,    //20MB
    //TAMANHO_LIMITE_PARA_VISUALIZACAO: 2,    //20MB
    TAMANHO_LIMITE_UPLOAD_CAPA_JORNAL: 2097152,    //2MB
    TAMANHO_LIMITE_UPLOAD_JORNAL: 115343360,       //110MB
    TAMANHO_LIMITE_UPLOAD_ANEXO_ATO: 115343360,    //110MB
}
    
export default documentos;
